import { makeActions } from '@redux/crudCreator/actions';

export const MODEL_NAME = 'locationStockChanges';
export const locationStockChangesActions = makeActions(
  MODEL_NAME,
  'id',
  'location-stock-changes',
);

export const getAllLocationStockChanges = locationStockChangesActions.getAll;
export const editLocationStockChanges = locationStockChangesActions.edit;
export const createLocationStockChanges = locationStockChangesActions.create;
export const getByIdLocationStockChanges =
  locationStockChangesActions.getDataById;
